import { FormEvent, useState } from 'react';
import type { CSSProperties } from 'react';
import type { PartnerTheme } from '../types';
import { approveTvPairing } from '../core/api';
import { BrandMark } from './BrandMark';

export function PairingActivationScreen({ code, theme }: { code: string; theme: PartnerTheme }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [approved, setApproved] = useState(false);
  const signupUrl = new URL('/signup', import.meta.env.VITE_WEBPLAYER_URL || 'https://app-hml.innova.tv.br');
  signupUrl.searchParams.set('pair', code);
  if (theme.slug) signupUrl.searchParams.set('partner', theme.slug);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (!email || !password) return;
    setBusy(true);
    setError('');
    try {
      await approveTvPairing(code, email.trim(), password);
      setApproved(true);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'Não foi possível autorizar a TV.');
    } finally {
      setPassword('');
      setBusy(false);
    }
  };

  return <main className="pairing-activation" data-testid="pairing-activation" style={{ '--partner-accent': theme.primary_color } as CSSProperties}>
    <section className="pairing-activation__card">
      <BrandMark theme={theme} />
      {approved ? <div className="pairing-success" data-testid="pairing-approved">
        <span>✓</span><h1>TV conectada</h1><p>Você já pode voltar para a televisão.</p>
      </div> : <form onSubmit={submit}>
        <span className="eyebrow">AUTORIZAR TELEVISÃO</span>
        <h1>Entre para conectar</h1>
        <p>Confirme sua conta. Este código funciona somente uma vez.</p>
        <label><span>E-mail</span><input data-testid="pair-email" type="email" autoComplete="username" value={email} onChange={event => setEmail(event.target.value)} /></label>
        <label><span>Senha</span><input data-testid="pair-password" type="password" autoComplete="current-password" value={password} onChange={event => setPassword(event.target.value)} /></label>
        {error && <div className="form-error" role="alert">{error}</div>}
        <button className="primary-button" data-testid="pair-approve" disabled={busy}>{busy ? 'Autorizando…' : 'Conectar TV'}</button>
        <a className="pairing-signup" data-testid="pair-signup" href={signupUrl.toString()}>Ainda não tenho conta</a>
      </form>}
    </section>
  </main>;
}
